import { UPDATE_LOCKS } from '@/client/services/update/constants'

export default function isUpdateLocked(): boolean {
  return UPDATE_LOCKS.size > 0
}
